import { useEffect, useState } from "react"
import { MenuAdmin } from "../MenuAdmin"
import { Header } from "../../common/header/Header"
import { IMG } from "../../common/CONST"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { IFullCompanyDto } from "../../../types/company/IFullCompanyDto"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { useNavigate } from "react-router-dom"
import { useStore } from "../../../stores/RootStoreContext"
import { MenuManager } from "../../manager/MenuManager"
import { ADMIN_COMPANY_NEW_ROUTE } from "@/routes"
import Button from "@/ui/components/Button"
import Input from "@/ui/components/Input"

export const CompanyList = () => {
  const navigate = useNavigate()
  const { userStore } = useStore()

  const [companies, setCompanies] = useState<IFullCompanyDto[]>([])
  const [filteredCompanies, setFilteredCompanies] = useState<IFullCompanyDto[]>([])
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [search, setSearch] = useState("")

  useEffect(() => {
    TrinityAPI.getCompanyList(response => {
      if (response.status === 200) {
        setCompanies(response.data)
        setFilteredCompanies(response.data)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Не удалось загрузить список компаний: " + response.data.message })
      }
    })
  }, [])

  useEffect(() => {
    if (!search) {
      setFilteredCompanies(companies)
      return
    }

    setFilteredCompanies(
      companies.filter(
        c =>
          c.name?.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
          c.bankName?.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
          c.swift?.toLocaleLowerCase().includes(search.toLocaleLowerCase())
      )
    )
  }, [search])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      {userStore.isManager ? <MenuManager active={"company"} /> : <MenuAdmin active={"company"} />}
      <main className="main-container">
        <Header />

        <div className="container">
          <h1 className="ui-heading">Реестр зарубежных компаний</h1>

          <section className="header-chapter">
            <div className="headr-chapter-name">
              <div className="header-chapter-icon">
                <img src={IMG.companies} alt="" className="header-chapter-img" />
              </div>
              <h2 className="heading-chapter">Все компании</h2>
            </div>
            {userStore.isAdmin ? (
              <Button
                onClick={() => navigate(ADMIN_COMPANY_NEW_ROUTE)}
                leftIcon={<img src={IMG.plus_btn} alt="" className="img-btn" />}
              >
                Добавить
              </Button>
            ) : null}
          </section>

          <section className="search-block">
            <Input
              type="search"
              onChange={e => setSearch(e.target.value)}
              placeholder="Поиск по названию, банку или SWIFT"
            />
          </section>

          <div className="main-content--wrapper">
            <section className="main-content">
              <ul className="header-global-list">
                <li className="header-global-item cols-company">Название</li>
                <li className="header-global-item width-130">Юрисдикция</li>
                <li className="header-global-item cols-company">Адрес</li>
              </ul>
              <ul className="global-list">
                {filteredCompanies.map((c, index) => (
                  <li
                    className="global-item"
                    style={{ cursor: "pointer" }}
                    key={index}
                    onClick={() => navigate(`/company/${c.id}`)}
                  >
                    <div className="global-scroll-block">
                      <p className="global-item-text global-name cols-company">{c.name}</p>
                      <p className="global-item-text global-name width-130">{c.country?.name?.toUpperCase()}</p>
                      <p className="global-item-text global-name cols-company">{c.address}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </section>
          </div>
        </div>
      </main>
    </>
  )
}
